import {i18n, MessageDescriptor} from '@lingui/core';

export const getTitleText = (title: string | MessageDescriptor): string => {
    return typeof title === 'string' ? title : i18n._(title);
};